export const setSessionData = (data: { token: string; user: any }) => {
  localStorage.setItem("token", data.token);
  localStorage.setItem("user", JSON.stringify(data.user));
};

export const getSessionData = () => {
  const token = localStorage.getItem("token");
  const user = localStorage.getItem("user");
  return {
    token,
    user: user ? JSON.parse(user) : null,
  };
};

export const clearSessionData = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};
